<script setup lang="ts">
import FirefoxDragAndDrop from '@/components/FirefoxComponents/FirefoxDragAnDrop.vue'
import { RouterView } from 'vue-router'
</script>

<template>
    <FirefoxDragAndDrop />
    <div class="app-content">
        <RouterView />
    </div>
</template>
